import Link from "next/link";

const Index = ({
	               href,
	               text,
	               start_icon,
	               color_type = "default",
	               end_icon,
	               disabled,
	               loading,
	               shimmer,
	               badge,
	               badge_type = "default",
	               tooltip,
	               tooltip_placement="top",
	               horizontal_tooltip_placement = "center",
	               component,
	               shimmer_style,
	               className,
	               options,
	               ...props
               }) => {

	return (
		shimmer ?
			<div className={`loading-animation ${shimmer_style}`}/>
			:
			<Link
				href={href}
				className={`${className ? className : ''} button-component link ${options?.btn?.[color_type]}`}
				disabled={disabled || shimmer || loading}
				{...props}
			>
				{start_icon &&
					<span className="button-icon start-icon">
					{loading ?
						<span className="spinner"/>
						:
						start_icon}
				</span>
				}

				{text && <span className={`button-text ${loading ? 'flex':''}`}>

				{(loading && !(start_icon || end_icon)) ?
					<span className="spinner"/> : text}</span>
				}

				{end_icon &&
					<span className="button-icon end-icon">
					{loading ?
						<span className="spinner"/>
						:
						end_icon}
				</span>
				}

				{badge && <span className={`button-badge ${options?.badge?.[badge_type]}`}>{badge}</span>}

				{tooltip && <span className={`tooltip
				 ${tooltip_placement === 'top' ?'top-tooltip' : 'bottom-tooltip'}
				 ${horizontal_tooltip_placement === 'center' && 'horizontal-center-tooltip-placement'}
					${horizontal_tooltip_placement === 'right' && 'horizontal-right-tooltip-placement'}
					${horizontal_tooltip_placement === 'left' && 'horizontal-left-tooltip-placement'}
					`}>
					{tooltip}
				</span>}

				{((!start_icon || !end_icon || !text) && component) && (loading ?
					<span className="spinner"/> : component)}
			</Link>
	)
}

export default Index